var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarDiesel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 292,
    viewBox: "0 0 646 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10696_10145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.48 238.573L599.68 238.573L599.68 249.094L521.789 250.214L259.687 250.214L259.687 264.762",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.043 242.095L511.043 261.629L576.398 261.629L576.398 242.095",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.398 242.094C576.398 241.212 576.325 240.352 576.187 239.51",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.496 234.62C571.847 229.776 566.705 226.488 560.794 226.488L526.649 226.488C519.818 226.488 514.01 230.878 511.897 236.992",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.258 239.51C511.12 240.348 511.046 241.212 511.046 242.094",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 264.875L239.099 267.074L228.205 267.074L222.761 264.987L149.791 263.717",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.301 264.086L133.003 264.086L81.8204 263.714L57.2726 262.146C57.2726 262.146 42.9484 261.623 31.234 250.285L29.4451 248.57",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5742 262.148C57.5742 262.148 55.202 259.206 46.5642 255.611C46.5642 255.611 39.711 252.759 32.7974 251.666",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5156 239.804L62.9471 250.995C62.9471 250.995 62.6662 253.458 57.5198 253.401L36.3122 249.988L28.8152 248.476C28.8152 248.476 11.9717 237.397 6.43217 217.085C6.43217 217.085 2.79388 203.937 3.85685 202.144C3.85685 202.144 3.85682 201.638 6.03895 200.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.707 248.418C29.707 248.418 24.336 244.391 17.3964 234.54C17.3964 234.54 10.5692 224.299 10.1241 215.74",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8164 250.043C36.8164 250.043 27.3058 245.286 23.4428 237.621C23.4428 237.621 19.636 231.355 17.2896 224.023",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9961 252.895L49.5195 248.25L40.5101 243.492L35.1952 240.973C35.1952 240.973 33.7391 240.135 32.7323 240.973C32.7323 240.973 32.2829 241.086 32.957 241.924C32.957 241.924 38.5527 249.032 42.0787 250.933",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7109 242.098C37.7109 242.098 33.7399 238.572 30.996 231.468",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0193 248.531C57.0193 248.531 58.9768 248.756 59.707 247.244L59.707 245.956C59.707 245.956 59.37 244.444 57.5811 242.88C57.5811 242.88 52.0976 238.066 43.0883 236.727C43.0883 236.727 38.387 236.221 38.387 238.909C38.387 238.909 38.387 240.922 42.5266 243.722C42.5266 243.722 46.3896 246.799 53.7181 248.479L57.0193 248.536L57.0193 248.531Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.514 260.284C250.514 260.284 254.766 257.821 254.766 252.9C254.766 252.9 253.422 250.774 248.833 253.012L242.455 255.7L156.06 255.7L154.271 261.295L214.385 261.312L250.514 260.288L250.514 260.284Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.688 250.213C259.688 250.213 258.793 248.645 246.033 248.645L203.173 248.645C203.173 248.645 176.313 247.638 159.193 250.658L127.745 254.573L127.745 264.195",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.307 263.867L138.936 261.628L138.599 263.085L137.593 272.819C136.473 281.884 144.42 287.817 144.42 287.817L152.703 291.623C157.405 292.518 156.398 289.498 156.398 289.498L154.159 277.857C153.04 272.487 149.795 268.792 149.795 268.792L149.795 262.415C149.795 262.415 149.449 260.998 148.088 260.998L145.431 261.883L142.782 260.626L138.941 261.633",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.789 268.788L146.881 267.855C146.881 267.855 142.888 267.704 137.63 271.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.445 291.691L151.613 287.193C151.142 286.04 150.723 284.869 150.351 283.676L147.055 273.086C146.717 272.002 146.631 270.852 146.804 269.724L147.098 267.815L145.529 261.735",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.041 180.895C163.739 180.895 155.387 191.885 155.387 205.442C155.387 218.998 163.739 229.988 174.041 229.988C184.344 229.988 192.695 218.998 192.695 205.442C192.695 191.885 184.344 180.895 174.041 180.895Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.039 183.917C182.655 183.917 189.668 193.57 189.668 205.439C189.668 217.308 182.659 226.961 174.039 226.961C165.418 226.961 158.41 217.308 158.41 205.439C158.41 193.57 165.418 183.917 174.039 183.917Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2891 224.023C17.2891 224.023 7.6661 193.959 7.6661 152.48",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96458 154.719L14.9727 150.281L14.9727 142.111L9.96459 137.111L6.46883 140.629L6.46882 151.37L9.96458 154.719Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.256 186.537L168.256 201.867L171.052 233.314C171.052 233.314 172.059 238.348 163.667 238.909L112.861 241.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.306 238.797L157.513 206.011L158.856 176.132L159.975 174.227L167.922 180.829",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.855 176.133C158.855 176.133 141.623 176.133 133.227 170.987C133.227 170.987 130.652 169.755 130.207 165.728C129.762 161.701 130.207 145.472 130.207 145.472",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.689 162.254L140.166 162.254C141.278 162.254 142.18 161.352 142.18 160.24L142.18 131.814C142.18 130.702 141.278 129.8 140.166 129.8L135.689 129.8C134.577 129.8 133.676 130.702 133.676 131.814L133.676 160.24C133.676 161.352 134.577 162.254 135.689 162.254Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.952 27.1309L613.762 27.131C615.313 27.131 616.86 27.3297 618.364 27.7273L633.125 31.6117C633.725 31.7845 634.188 32.2598 634.339 32.8647C635.346 36.8701 639.174 52.4466 641.252 65.3485C643.659 80.2855 645.785 111.395 645.785 111.395L645.785 180.61C645.785 180.61 643.659 211.72 641.252 226.661C639.174 239.563 635.341 255.14 634.339 259.145C634.187 259.75 633.725 260.225 633.125 260.398L618.364 264.283C616.86 264.676 615.313 264.879 613.762 264.879L249.952 264.879",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.957 142.617L265.957 142.73L265.957 30.2981L618.255 30.2981L625.567 32.2382L626.163 37.7602L617.361 51.3404L619.448 53.8768L627.355 131.759L627.355 142.73L627.355 149.276L627.355 160.242L619.448 238.129L617.361 240.665L626.163 254.241L625.567 259.763L618.255 261.703L265.957 261.703L265.957 149.276L265.957 149.388L265.957 142.617Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.48 53.4258L599.68 53.4258L599.68 42.9046L521.789 41.7855L259.687 41.7855L259.687 27.2417",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.043 49.9102L511.043 30.3758L576.398 30.3758L576.398 49.9102",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.398 49.9084C576.398 50.7898 576.325 51.6496 576.187 52.4922",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.496 57.38C571.847 62.2236 566.705 65.5117 560.794 65.5117L526.649 65.5117C519.818 65.5117 514.01 61.1218 511.897 55.0078",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.258 52.4883C511.12 51.65 511.046 50.7859 511.046 49.9044",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.953 27.1315L239.099 24.9279L228.205 24.9279L222.761 27.0192L149.791 28.2851",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.301 27.9137L133.003 27.9137L81.8204 28.2852L57.2726 29.8537C57.2726 29.8537 42.9484 30.3765 31.234 41.7143L29.4451 43.4297",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5742 29.8537C57.5742 29.8537 55.202 32.7961 46.5642 36.391C46.5642 36.391 39.711 39.2428 32.7974 40.3359",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5156 52.1953L62.9471 41.0044C62.9471 41.0044 62.6662 38.5416 57.5198 38.5978L36.3122 42.0112L28.8152 43.5235C28.8152 43.5235 11.9717 54.602 6.43217 74.9141C6.43217 74.9141 2.79387 88.0623 3.85685 89.8554C3.85685 89.8554 3.85682 90.361 6.03894 91.1992",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.707 43.5796C29.707 43.5796 24.336 47.6066 17.3964 57.458C17.3964 57.458 10.5692 67.6983 10.1241 76.2578",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8164 41.9528C36.8164 41.9528 27.3058 46.71 23.4428 54.3751C23.4428 54.3751 19.636 60.6403 17.2896 67.9727",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9961 39.1009L49.5195 43.7458L40.5101 48.503L35.1952 51.022C35.1952 51.022 33.7391 51.8602 32.7323 51.022C32.7323 51.022 32.2829 50.9097 32.957 50.0714C32.957 50.0714 38.5527 42.9637 42.0787 41.0625",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7109 49.9021C37.7109 49.9021 33.7399 53.4278 30.996 60.5312",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0193 43.4664C57.0193 43.4664 58.9768 43.2417 59.707 44.754L59.707 46.0416C59.707 46.0416 59.37 47.5539 57.5811 49.118C57.5811 49.118 52.0976 53.9314 43.0883 55.2708C43.0883 55.2708 38.387 55.7764 38.387 53.0888C38.387 53.0888 38.387 51.0753 42.5266 48.2754C42.5266 48.2754 46.3896 45.199 53.7181 43.5182L57.0193 43.462L57.0193 43.4664Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.514 31.719C250.514 31.719 254.766 34.1818 254.766 39.1032C254.766 39.1032 253.422 41.2291 248.833 38.9909L242.455 36.3033L156.06 36.3033L154.271 30.7079L214.385 30.6906L250.514 31.7146L250.514 31.719Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.688 41.7861C259.688 41.7861 258.793 43.3545 246.033 43.3545L203.173 43.3545C203.173 43.3545 176.313 44.3613 159.193 41.341L127.745 37.4264L127.745 27.804",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.307 28.1383L138.936 30.3765L138.599 28.9204L137.593 19.1856C136.473 10.1205 144.42 4.18809 144.42 4.18809L152.703 0.381461C157.405 -0.512945 156.398 2.50729 156.398 2.50729L154.159 14.1475C153.04 19.5183 149.795 23.2126 149.795 23.2126L149.795 29.5901C149.795 29.5901 149.449 31.0073 148.088 31.0073L145.431 30.1215L142.782 31.3789L138.941 30.3721",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.789 23.2105L146.881 24.1438C146.881 24.1438 142.888 24.295 137.63 20.2292",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.445 0.305576L151.613 4.80355C151.142 5.9572 150.723 7.12815 150.351 8.32069L147.055 18.911C146.717 19.9955 146.631 21.1448 146.804 22.2726L147.098 24.1823L145.529 30.2617",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.957 53.5769L224.324 53.5769L204.775 51.7881L152.253 43.5829L128.379 41.6429L106.148 41.0466C106.148 41.0466 97.9679 39.3485 93.3487 47.6012C92.4932 49.1308 90.1123 55.8367 88.4357 60.4124C83.3066 74.3946 72.9102 107.259 72.9102 143.856L72.9102 148.164C72.9102 184.757 83.3066 217.625 88.4357 231.607C90.1123 236.183 92.4975 242.889 93.3487 244.418C97.9679 252.671 106.148 250.973 106.148 250.973L128.379 250.377L152.253 248.437L204.775 240.231L224.324 238.443L265.957 238.443",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.207 46.1143L59.7381 53.2782L32.5804 60.1397L25.2691 62.676C25.2691 62.676 11.5412 68.3449 7.36276 82.8196C7.36276 82.8196 0.682423 110.373 0.22439 142.632C0.207105 143.777 0.207105 148.211 0.224389 149.347C0.678096 181.615 7.36275 209.181 7.36275 209.181C11.5412 223.656 25.2691 229.325 25.2691 229.325L32.5803 231.861L59.7381 238.723L94.207 245.887",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2891 67.9757C17.2891 67.9757 7.6661 98.0398 7.66609 139.52",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.055 41.6769L99.8828 60.3644C99.8828 60.3644 84.353 90.6921 83.2684 141.587C83.2295 143.432 83.2468 150.064 83.3246 152.622C84.8024 202.186 99.8828 231.637 99.8828 231.637L124.055 250.324",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.188 47.0478C174.188 47.0478 179.334 48.5039 178.552 56.5578L173.069 78.1575L168.592 104.679C168.592 104.679 165.122 124.373 165.122 145.636L165.122 146.361C165.122 167.624 168.592 187.318 168.592 187.318L173.069 213.839L178.552 235.439C179.334 243.497 174.188 244.949 174.188 244.949",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.256 105.461L168.256 90.1307L171.052 58.6839C171.052 58.6839 172.059 53.6502 163.667 53.0885L112.861 50.0682",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.306 53.2034L157.513 85.9939L158.856 115.872L159.975 117.773L167.922 111.171",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.977 117.771L159.977 144.966L159.977 147.036L159.977 174.227",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.082 61.708L156.507 62.9394L147.778 58.6877C147.778 58.6877 129.647 53.9867 125.62 65.1776C125.62 65.1776 115.867 91.5431 115.448 142.485C115.44 143.6 115.44 148.392 115.448 149.498C115.863 200.453 125.62 226.823 125.62 226.823C129.647 238.014 147.778 233.313 147.778 233.313L156.507 229.061L159.082 230.293",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.777 58.6861C147.777 58.6861 133.678 55.9986 129.314 71.3331L125.844 92.0341C125.844 92.0341 123.048 116.092 123.048 130.083L123.048 161.919C123.048 175.905 125.844 199.968 125.844 199.968L129.314 220.669C133.678 235.999 147.777 233.316 147.777 233.316",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.742 113.293C158.742 113.293 151.133 111.504 141.73 113.63C141.73 113.63 135.577 115.086 129.195 119.675L127.851 145.47L129.195 172.328C135.573 176.917 141.73 178.373 141.73 178.373C151.133 180.499 158.742 178.71 158.742 178.71",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.855 115.871C158.855 115.871 141.623 115.871 133.227 121.017C133.227 121.017 130.652 122.248 130.207 126.275C129.762 130.302 130.207 146.531 130.207 146.531",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.094 125.719L133.901 123.368L147.106 123.368C150.464 123.368 149.344 125.494 149.344 125.494L149.344 146.307L149.344 145.694L149.344 166.507C149.344 166.507 150.464 168.633 147.106 168.633L133.901 168.633L130.094 166.282",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.689 162.199L140.166 162.199C141.278 162.199 142.18 161.298 142.18 160.186L142.18 131.759C142.18 130.647 141.278 129.746 140.166 129.746L135.689 129.746C134.577 129.746 133.676 130.647 133.676 131.759L133.676 160.186C133.676 161.298 134.577 162.199 135.689 162.199Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.977 133.439L155.837 133.214C155.837 133.214 154.048 132.432 154.048 134.783L154.048 157.221C154.048 159.571 155.837 158.789 155.837 158.789L159.977 158.565",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.689 233.582L187.003 233.582C184.376 233.582 182.245 231.452 182.245 228.825L182.245 182.048C182.245 179.421 184.376 177.291 187.003 177.291L251.689 177.291C255.612 177.291 258.797 180.475 258.797 184.398L258.797 226.474C258.797 230.398 255.612 233.582 251.689 233.582Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.051 202.826L248.051 201.781C248.051 200.104 247.602 198.423 247.602 198.423C246.733 194.872 247.463 193.221 247.463 193.221C248.358 190.088 251.184 190.145 251.184 190.145C254.96 189.838 256.218 193.39 256.218 193.39C256.218 193.39 258.344 198.873 258.344 205.138L258.344 205.734C258.344 211.999 256.218 217.482 256.218 217.482C256.218 217.482 254.96 221.034 251.184 220.727C251.184 220.727 248.358 220.783 247.463 217.651C247.463 217.651 246.737 216 247.602 212.449C247.602 212.449 248.051 210.772 248.051 209.091L248.051 202.826Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.872 228.862L245.899 228.862C248.976 228.862 251.465 226.369 251.465 223.297L251.465 187.581C251.465 184.505 248.972 182.016 245.899 182.016L234.872 182.016L226.921 183.313C226.921 183.313 233.731 189.366 233.731 205.444C233.731 221.521 226.921 227.575 226.921 227.575L234.872 228.871L234.872 228.862Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.066 233.453L240.066 177.425",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.695 233.453L234.695 177.425",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.915 183.309L230.441 177.389",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.917 227.568L230.668 233.492",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.621 224.203L206.642 224.203C203.471 224.203 200.9 221.632 200.9 218.461L200.9 192.424C200.9 189.252 203.471 186.681 206.642 186.681L234.621 186.681",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.689 169.336L187.003 169.336C184.376 169.336 182.245 167.206 182.245 164.579L182.245 117.802C182.245 115.175 184.376 113.044 187.003 113.044L251.689 113.045C255.612 113.045 258.797 116.229 258.797 120.152L258.797 162.228C258.797 166.152 255.612 169.336 251.689 169.336Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.051 138.58L248.051 137.534C248.051 135.858 247.602 134.177 247.602 134.177C246.733 130.626 247.463 128.975 247.463 128.975C248.358 125.842 251.184 125.899 251.184 125.899C254.96 125.592 256.218 129.143 256.218 129.143C256.218 129.143 258.344 134.627 258.344 140.892L258.344 141.488C258.344 147.753 256.218 153.236 256.218 153.236C256.218 153.236 254.96 156.788 251.184 156.481C251.184 156.481 248.358 156.537 247.463 153.405C247.463 153.405 246.737 151.754 247.602 148.203C247.602 148.203 248.051 146.526 248.051 144.845L248.051 138.58Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.872 164.616L245.899 164.616C248.976 164.616 251.465 162.123 251.465 159.051L251.465 123.335C251.465 120.259 248.972 117.77 245.899 117.77L234.872 117.77L226.921 119.066C226.921 119.066 233.731 125.12 233.731 141.198C233.731 157.275 226.921 163.329 226.921 163.329L234.872 164.625L234.872 164.616Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.066 169.203L240.066 113.18",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.695 169.203L234.695 113.18",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.915 119.059L230.441 113.139",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.917 163.323L230.668 169.242",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.621 159.949L206.642 159.949C203.471 159.949 200.9 157.378 200.9 154.207L200.9 128.17C200.9 124.998 203.471 122.427 206.642 122.427L234.621 122.427",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.689 113.043L187.003 113.043C184.376 113.043 182.245 110.913 182.245 108.286L182.245 61.5087C182.245 58.8817 184.376 56.7515 187.003 56.7515L251.689 56.7515C255.612 56.7515 258.797 59.936 258.797 63.8593L258.797 105.935C258.797 109.859 255.612 113.043 251.689 113.043Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.051 82.2872L248.051 81.2415C248.051 79.5651 247.602 77.8843 247.602 77.8843C246.733 74.3326 247.463 72.682 247.463 72.682C248.358 69.5494 251.184 69.6056 251.184 69.6056C254.96 69.2988 256.218 72.8505 256.218 72.8505C256.218 72.8505 258.344 78.3336 258.344 84.5988L258.344 85.1951C258.344 91.4602 256.218 96.9433 256.218 96.9433C256.218 96.9433 254.96 100.495 251.184 100.188C251.184 100.188 248.358 100.244 247.463 97.1118C247.463 97.1118 246.737 95.4613 247.602 91.9096C247.602 91.9096 248.051 90.2331 248.051 88.5523L248.051 82.2872Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.872 108.323L245.899 108.323C248.976 108.323 251.465 105.83 251.465 102.758L251.465 67.0424C251.465 63.966 248.972 61.4772 245.899 61.4772L234.872 61.4772L226.921 62.7735C226.921 62.7735 233.731 68.8269 233.731 84.9046C233.731 100.982 226.921 107.036 226.921 107.036L234.872 108.332L234.872 108.323Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.066 112.914L240.066 56.8862",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.695 112.914L234.695 56.8862",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.915 62.7695L230.441 56.8501",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.917 107.029L230.668 112.953",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.621 103.664L206.642 103.664C203.471 103.664 200.9 101.093 200.9 97.9217L200.9 71.8846C200.9 68.7131 203.471 66.1422 206.642 66.1422L234.621 66.1422",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.405 17.9687L491.5 17.9688L491.5 16.0287L343.405 16.0287L343.405 17.9687Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.726 27.1484L471.129 27.1484L471.129 22.0758L466.726 22.0758L466.726 27.1484Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.913 27.1484L368.316 27.1484L368.316 22.0758L363.913 22.0758L363.913 27.1484Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.74 23.2662C351.011 23.2662 351.905 22.0737 351.905 22.0737L360.037 22.0737C360.037 23.2662 362.051 23.0416 362.051 23.0416C363.468 23.0416 363.918 22.1472 363.918 22.1472L471.728 22.1472L472.635 23.7891L481.614 23.7891C483.408 23.7891 484.859 22.3373 484.859 20.5441L484.859 16.1801L347.506 16.1801L347.506 21.5509C347.506 23.0416 349.745 23.2662 349.745 23.2662L349.74 23.2662Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.225864 149.348C0.532656 170.947 3.62653 190.438 5.64014 200.968C3.85987 201.711 3.85987 202.152 3.85987 202.152C2.79689 203.941 6.43519 217.093 6.43519 217.093C11.9748 237.406 28.8182 248.484 28.8182 248.484L29.4966 248.622L31.2423 250.295C42.9566 261.632 57.2809 262.155 57.2809 262.155L81.8287 263.724L127.748 264.056L127.748 264.208L129.075 264.065L133.007 264.095L138.499 264.095L137.708 271.721C137.683 271.743 137.657 271.76 137.631 271.778L137.704 271.76L137.596 272.823C136.477 281.888 144.423 287.821 144.423 287.821L152.707 291.627C157.408 292.522 156.401 289.501 156.401 289.501L154.163 277.861C153.044 272.49 149.799 268.796 149.799 268.796L149.799 263.724L222.764 264.994L228.208 267.081L239.102 267.081L249.956 264.882L613.762 264.882C615.313 264.882 616.86 264.683 618.364 264.285L633.125 260.401C633.725 260.228 634.187 259.753 634.339 259.148C635.346 255.143 639.174 239.566 641.252 226.664C643.659 211.718 645.785 180.609 645.785 180.609L645.785 111.394C645.785 111.394 643.659 80.2839 641.252 65.3425C639.174 52.4406 635.341 36.8641 634.339 32.8587C634.188 32.2538 633.725 31.7785 633.125 31.6057L618.364 27.7213C616.86 27.3281 615.313 27.125 613.762 27.125L471.129 27.125L471.129 22.1431L471.725 22.1431L472.632 23.785L481.612 23.785C483.405 23.785 484.857 22.3332 484.857 20.5401L484.857 17.9649L491.498 17.9649L491.498 16.0249L343.403 16.0248L343.403 17.9649L347.508 17.9649L347.508 21.5468C347.508 23.0375 349.746 23.2622 349.746 23.2622C351.017 23.2622 351.911 22.0697 351.911 22.0697L360.043 22.0697C360.043 23.2622 362.057 23.0375 362.057 23.0375C363.474 23.0375 363.924 22.1431 363.924 22.1431L363.924 27.125L249.96 27.125L239.106 24.9257L228.213 24.9257L222.768 27.0126L149.803 28.2829L149.803 23.2103C149.803 23.2103 153.048 19.516 154.167 14.1453L156.406 2.50504C156.406 2.50504 157.412 -0.515196 152.711 0.37921L144.428 4.18584C144.428 4.18584 136.481 10.1183 137.6 19.1833L137.708 20.2463L137.635 20.229C137.661 20.2506 137.687 20.2679 137.713 20.2852L138.499 27.8984L138.305 27.9114L133.007 27.9114L129.075 27.9416L127.748 27.799L127.748 27.9503L81.8287 28.2829L57.2809 29.8514C57.2809 29.8514 42.9567 30.3742 31.2423 41.712L29.4966 43.3841L28.8182 43.5224C28.8182 43.5224 11.9748 54.601 6.4352 74.9131C6.4352 74.9131 2.7969 88.0613 3.85988 89.8544C3.85988 89.8544 3.85988 90.2951 5.64015 91.0383C3.62654 101.564 0.53266 121.042 0.225864 142.637C0.20858 143.782 0.208579 148.215 0.225864 149.352L0.225864 149.348Z",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.315 27.1484L466.723 27.1484L466.723 22.0758L368.315 22.0758L368.315 27.1484Z",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.129 27.1289L466.726 27.1289",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.316 27.1484L363.913 27.1484",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 43V249H627V43H416Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M416 43V249H627V43H416Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416 200H361V249H416V200Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M412.863 202H363.863V246H412.863V202Z",
    fill: "#C9C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M412.863 202L412.863 197L363.863 197L363.863 202L412.863 202Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M412.863 202H363.863V246H412.863V202Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M413 214H364V246H413V214Z",
    fill: "#C9C9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M413 214H364V246H413V214Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 184H283.605C283.357 184 283.156 184.239 283.156 184.534V185.466C283.156 185.761 283.357 186 283.605 186H347.526C347.773 186 347.974 185.761 347.974 185.466V184.534C347.974 184.239 347.773 184 347.526 184Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 190H283.605C283.357 190 283.156 190.239 283.156 190.534V191.466C283.156 191.761 283.357 192 283.605 192H347.526C347.773 192 347.974 191.761 347.974 191.466V190.534C347.974 190.239 347.773 190 347.526 190Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 196H283.605C283.357 196 283.156 196.239 283.156 196.534V197.466C283.156 197.761 283.357 198 283.605 198H347.526C347.773 198 347.974 197.761 347.974 197.466V196.534C347.974 196.239 347.773 196 347.526 196Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 202H283.605C283.357 202 283.156 202.239 283.156 202.534V203.466C283.156 203.761 283.357 204 283.605 204H347.526C347.773 204 347.974 203.761 347.974 203.466V202.534C347.974 202.239 347.773 202 347.526 202Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 208H283.605C283.357 208 283.156 208.239 283.156 208.534V209.466C283.156 209.761 283.357 210 283.605 210H347.526C347.773 210 347.974 209.761 347.974 209.466V208.534C347.974 208.239 347.773 208 347.526 208Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 214H283.605C283.357 214 283.156 214.239 283.156 214.534V215.466C283.156 215.761 283.357 216 283.605 216H347.526C347.773 216 347.974 215.761 347.974 215.466V214.534C347.974 214.239 347.773 214 347.526 214Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 220H283.605C283.357 220 283.156 220.239 283.156 220.534V221.466C283.156 221.761 283.357 222 283.605 222H347.526C347.773 222 347.974 221.761 347.974 221.466V220.534C347.974 220.239 347.773 220 347.526 220Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 226H283.605C283.357 226 283.156 226.239 283.156 226.534V227.466C283.156 227.761 283.357 228 283.605 228H347.526C347.773 228 347.974 227.761 347.974 227.466V226.534C347.974 226.239 347.773 226 347.526 226Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 232H283.605C283.357 232 283.156 232.239 283.156 232.534V233.466C283.156 233.761 283.357 234 283.605 234H347.526C347.773 234 347.974 233.761 347.974 233.466V232.534C347.974 232.239 347.773 232 347.526 232Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M347.526 238H283.605C283.357 238 283.156 238.239 283.156 238.534V239.466C283.156 239.761 283.357 240 283.605 240H347.526C347.773 240 347.974 239.761 347.974 239.466V238.534C347.974 238.239 347.773 238 347.526 238Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M361 173H269V249H361V173Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M353.68 188C353.68 183.582 350.098 180 345.68 180H284.316C279.898 180 276.316 183.582 276.316 188V234C276.316 238.418 279.898 242 284.316 242H345.68C350.098 242 353.68 238.418 353.68 234V188Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M357.864 176H272.137V246H357.864V176Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M278.95 226.483L280.961 226.483C281.503 226.483 281.941 226.063 281.941 225.547L281.941 199.936C281.941 199.42 281.503 199.001 280.961 199L278.95 199.001C278.409 199.001 277.97 199.42 277.97 199.937L277.97 225.547C277.97 226.063 278.409 226.483 278.95 226.483Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M278.429 222.133C277.09 223.411 276.997 225.395 278.222 226.564C279.448 227.733 281.526 227.645 282.866 226.367C284.204 225.089 284.297 223.105 283.072 221.936C281.847 220.766 279.768 220.855 278.429 222.133Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M283.916 224.217C283.916 224.217 284.082 223.052 286.699 218.462C286.714 215.209 283.581 216.941 283.581 216.941C283.581 216.941 281.181 220.133 278.422 222.128",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M283.916 224.217C283.916 224.217 284.082 223.052 286.699 218.462C286.714 215.209 283.581 216.941 283.581 216.941C283.581 216.941 281.181 220.133 278.422 222.128",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M600 213H416V249H600V213Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M600 213H416V249H600V213Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M416 43H345V98H416V43Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M416 43H345V98H416V43Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M359.41 49.4453L401.452 49.4456C408.884 49.4456 408.884 55.8454 408.884 55.8454V85.4326C408.884 88.9655 405.554 91.833 401.452 91.833H359.417C355.314 91.833 351.984 88.9655 351.984 85.4326V55.8457C351.984 52.3129 355.314 49.4453 359.417 49.4453H359.41Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M412.129 45H348.872C348.019 45 347.328 45.8711 347.328 46.9455V94.0545C347.328 95.1289 348.019 96 348.872 96H412.129C412.981 96 413.672 95.1289 413.672 94.0545V46.9455C413.672 45.8711 412.981 45 412.129 45Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M381.677 74.3389C383.935 74.3389 385.764 72.6916 385.764 70.6597C385.764 68.6278 383.935 66.9805 381.677 66.9805C379.419 66.9805 377.59 68.6278 377.59 70.6597C377.59 72.6916 379.419 74.3389 381.677 74.3389Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M381.68 73.8041C383.605 73.8041 385.165 72.3983 385.165 70.6638C385.165 68.9293 383.605 67.5234 381.68 67.5234C379.755 67.5234 378.195 68.9293 378.195 70.6638C378.195 72.3983 379.755 73.8041 381.68 73.8041Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M382.697 47.2679L380.462 47.2657C379.859 47.2651 379.371 47.6843 379.373 48.2017L379.407 65.4936C379.408 66.0105 379.897 66.4306 380.499 66.4317L382.735 66.4334C383.337 66.434 383.825 66.0153 383.824 65.4974L383.789 48.206C383.789 47.6886 383.3 47.2685 382.697 47.2679Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M382.376 52.384C384.479 52.384 386.185 51.0407 386.185 49.3834C386.185 47.7261 384.479 46.3828 382.376 46.3828C380.272 46.3828 378.566 47.7261 378.566 49.3834C378.566 51.0407 380.272 52.384 382.376 52.384Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M379.793 47.1953C379.793 47.1953 378.703 47.9072 372.87 49.3909C370.181 51.6862 374.067 52.5778 374.067 52.5778C374.067 52.5778 378.58 51.9391 382.389 52.3915",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M379.793 47.1953C379.793 47.1953 378.703 47.9072 372.87 49.3909C370.181 51.6862 374.067 52.5778 374.067 52.5778C374.067 52.5778 378.58 51.9391 382.389 52.3915",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M600 43H416V79H600V43Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M600 43H416V79H600V43Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M416 43H345V79H416V43Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M416 43H345V79H416V43Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M269 125L269 62L266 62L266 125L269 125Z",
    fill: "white",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M281 96.5L281 90.5L269 79L269 85L281 96.5Z",
    fill: "#D9D9D9",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M281 106.5L281 100.5L269 89L269 95L281 106.5Z",
    fill: "#D9D9D9",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M275 126L283 126L283 61L275 61L275 126Z",
    fill: "#D9D9D9",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10696_10145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 646,
    height: 292,
    fill: "white",
    transform: "translate(646 292) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDiesel);
export default __webpack_public_path__ + "static/media/car_diesel.0c1a4e72f66327d323a4c8df4530a1da.svg";
export { ForwardRef as ReactComponent };